module.exports = __webpack_public_path__ + "static/media/sura_logo.be4fa783.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/sura_logo.png
// module id = 605
// module chunks = 16